import script from "./AccessibleRoutes.vue?vue&type=script&setup=true&lang=js"
export * from "./AccessibleRoutes.vue?vue&type=script&setup=true&lang=js"

import "./AccessibleRoutes.vue?vue&type=style&index=0&id=475b03c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-475b03c8"]])

export default __exports__